/**
 * Centralized overlay cleaning utility for Stemblocks GUI.
 * Cleans up all extension DOM canvases, modals, grids, and overlays
 * when loading a project or creating a new project.
 */
export const cleanAllOverlays = (vm) => {
    if (typeof document === 'undefined') return;

    const performClean = () => {
        console.log('[OverlayCleaner] performClean triggered');

        // 1. Direct selector removal for known extension overlays
        const overlaySelectors = [
            '#coordinateCanvas',
            '#anglesCanvas',
            '#conversionChartCanvas',
            '#conversionChartCloseBtn',
            '.stemblocks-overlay-canvas',
            '.stemblocks-coordinate-canvas',
            '.stemblocks-angles-canvas',
            '.stemblocks-numbers-canvas',
            '.stemblocks-fractions-canvas',
            '.stemblocks-table-modal',
            '.stemblocks-overlay-modal',
            '.stemblocks-detection-overlay',
            '.stemblocks-detection-popup',
            '.p5Canvas',
            'canvas[id*="defaultCanvas"]',
            'canvas[class*="stemblocks"]',
            'canvas[id*="coordinate"]'
        ];

        overlaySelectors.forEach(selector => {
            try {
                const elements = document.querySelectorAll(selector);
                elements.forEach(el => {
                    console.log('[OverlayCleaner] Removing element matching selector:', selector, el);
                    try { el.remove(); } catch (e) {}
                });
            } catch (e) {}
        });

        // 2. Remove all non-main stage canvases
        try {
            const mainStageCanvas = vm && vm.runtime && vm.runtime.renderer && vm.runtime.renderer.canvas;
            const allCanvases = document.querySelectorAll('canvas');
            allCanvases.forEach(canvas => {
                if (mainStageCanvas && canvas === mainStageCanvas) return;
                // Never remove paint editor or loupe canvases
                if (canvas.closest && (
                    canvas.closest('[class*="paint-editor"]') ||
                    canvas.closest('[class*="scratch-paint"]') ||
                    canvas.closest('[class*="loupe"]')
                )) {
                    return;
                }
                if (
                    canvas.id === 'coordinateCanvas' ||
                    canvas.id === 'anglesCanvas' ||
                    canvas.classList.contains('stemblocks-coordinate-canvas') ||
                    canvas.classList.contains('stemblocks-angles-canvas') ||
                    canvas.classList.contains('stemblocks-numbers-canvas') ||
                    canvas.classList.contains('stemblocks-fractions-canvas') ||
                    canvas.classList.contains('stemblocks-overlay-canvas')
                ) {
                    console.log('[OverlayCleaner] Removing overlay canvas:', canvas.id, canvas.className);
                    try { canvas.remove(); } catch (e) {}
                    return;
                }

                const isInsideStage = canvas.closest && (
                    canvas.closest('.scratch-stage') ||
                    canvas.closest('[class*="stage-wrapper"]') ||
                    canvas.closest('[class*="stage_stage"]') ||
                    canvas.closest('[class*="stage-canvas-wrapper"]')
                );
                const style = window.getComputedStyle ? window.getComputedStyle(canvas) : canvas.style;
                const isOverlay = style && (style.position === 'absolute' || style.position === 'fixed');

                if (isInsideStage && isOverlay) {
                    console.log('[OverlayCleaner] Removing absolute canvas inside stage:', canvas);
                    try { canvas.remove(); } catch (e) {}
                }
            });
        } catch (e) {}

        // 3. Trigger VM runtime DOM cleaning if available
        if (vm && vm.runtime && typeof vm.runtime.cleanDOMOverlays === 'function') {
            try {
                vm.runtime.cleanDOMOverlays();
            } catch (e) {}
        }

        // 4. Clean Three.js CAD renderer
        if (typeof window !== 'undefined' && window.CADrenderer) {
            try {
                if (window.CADrenderer.domElement && typeof window.CADrenderer.domElement.remove === 'function') {
                    window.CADrenderer.domElement.remove();
                }
                if (typeof window.CADrenderer.dispose === 'function') {
                    window.CADrenderer.dispose();
                }
                window.CADrenderer = null;
                window.CADscene = null;
                window.CADcamera = null;
            } catch (e) {}
        }
    };

    // Perform immediately
    performClean();

    // One short deferred sweep to catch elements created synchronously right after this call.
    // Do NOT add longer delays — they race against the new project's rendering.
    if (typeof setTimeout !== 'undefined') {
        setTimeout(performClean, 50);
    }
};

// Global event hook
if (typeof window !== 'undefined' && !window.__stemblocks_overlay_cleaner_initialized__) {
    window.__stemblocks_overlay_cleaner_initialized__ = true;
    window.addEventListener('project-loaded', () => cleanAllOverlays());
    window.addEventListener('sb3-loaded', () => cleanAllOverlays());
}

export default cleanAllOverlays;
